const rbstateFormat = function(cellValue) {
  //金额格式化,保留两位小数
  if (cellValue) {
    cellValue = Number(cellValue).toFixed(2);
    cellValue += "";
    if (!cellValue.includes(".")) cellValue += ".";
    return cellValue
      .replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  } else {
    return "0.00";
  }
};
const rbstateFormatNotBack = function(cellValue) {
  //金额格式化,保留两位小数,无数据不返回
  if (cellValue) {
    cellValue = Number(cellValue).toFixed(2);
    cellValue += "";
    if (!cellValue.includes(".")) cellValue += ".";
    return cellValue
      .replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  } else {
    return "";
  }
};

export default {
  rbstateFormat,

  rbstateFormatNotBack
};



// WEBPACK FOOTER //
// ./src/filters/index.js